<script setup lang="ts">
</script>
<template>
    <div class="product-delivery-information flex flex-col py-4">
        <span class="text-sm" v-html="$t('productDeliveryInformationPrange.deliveryTime')" />
        <FoundationLink
            :href="$t('productDeliveryInformationPrange.linkDeliveryAndShippingCost')"
            class="text-sm"
            target="_blank"
        >
            {{ $t('productDeliveryInformationPrange.deliveryCostNotice') }}
        </FoundationLink>
        <span class="text-sm" v-html="$t('productDeliveryInformationPrange.deliveryCostReturns')" />
    </div>
</template>